export const contacts = {
  supportEmail: "support@cpj.ai",
  phone: "12365014000",
  address: "680 - 200 Burrard St, Vancouver, Canada",
};
